<!-- 
 * Copyright (c) 2024, ResMed Inc. All rights reserved.
 -->
<div class="main-div">
  <div class="search-bars">
    <ul>
      <!-- Textbox for search -->
      <li class="site-nav__item">
        <input
          type="text"
          id="patient-id"
          [(ngModel)]="patientId"
          class="site-nav__textbox"
          placeholder="Enter Patient ID"
        />
      </li>

      <!-- Button for executing search -->
      <li class="site-nav__item">
        <button id="searchBtn" class="site-nav__button" (click)="search()">
          Search
        </button>
      </li>
    </ul>
  </div>
  <main>
    <!-- Alert messages -->
    <div id="query-err" class="alert alert-danger fade" role="alert">
      {{ errorMsg }}
    </div>

    <!-- Modals -->

    <!-- Trigger Survey Modal -->
    <app-trigger-survey></app-trigger-survey>

    <!-- HME Consent Modal -->
    <app-hme-consent></app-hme-consent>

    <!-- MQUI modal -->
    <app-mqui-integration></app-mqui-integration>

    <div id="results" class="hidden displayed">
      <table id="resultTable" class="tables">
        <th colspan="2" class="patient-search-header">
          <h1><strong id="patient-search-header">Patient Profile</strong></h1>
        </th>
        <tr>
          <div class="patient-search-results">
            <ng-container *ngIf="this.response?.patient_profile?.Items">
              <div class="search-results">
                <h2>Patient Scope</h2>
                <p>
                  <strong>Platforms:</strong>
                  {{
                    this.response.patient_profile.Items[0]?.patientScope
                      ?.platforms?.length
                      ? this.response.patient_profile.Items[0].patientScope.platforms.join(
                          ", "
                        )
                      : "None"
                  }}
                </p>

                <!-- Display Regions -->
                <p>
                  <strong>Regions:</strong>
                  {{
                    this.response.patient_profile.Items[0]?.patientScope
                      ?.regions?.length
                      ? this.response.patient_profile.Items[0].patientScope.regions.join(
                          ", "
                        )
                      : "None"
                  }}
                </p>

                <!-- Display Countries -->
                <p>
                  <strong>Countries:</strong>
                  {{
                    this.response.patient_profile.Items[0]?.patientScope
                      ?.countries?.length
                      ? this.response.patient_profile.Items[0].patientScope.countries.join(
                          ", "
                        )
                      : "None"
                  }}
                </p>

                <!-- Display Locales -->
                <p>
                  <strong>Locales:</strong>
                  {{
                    this.response.patient_profile.Items[0]?.patientScope
                      ?.locales?.length
                      ? this.response.patient_profile.Items[0].patientScope.locales.join(
                          ", "
                        )
                      : "None"
                  }}
                </p>

                <!-- Display Groups -->
                <p>
                  <strong>Groups:</strong>
                  {{
                    this.response.patient_profile.Items[0]?.patientScope?.groups
                      ?.length
                      ? this.response.patient_profile.Items[0].patientScope.groups.join(
                          ", "
                        )
                      : "None"
                  }}
                </p>
              </div>
              <div class="search-results">
                <h2>Other Details</h2>
                <p>
                  <strong>Survey Response Source ID:</strong>
                  {{
                    this.response.patient_profile.Items[0]
                      ?.surveyResponseSourceId || "None"
                  }}
                </p>

                <!-- Display Source ID -->
                <p>
                  <strong>Source ID:</strong>
                  {{
                    this.response.patient_profile.Items[0]?.sourceId || "None"
                  }}
                </p>

                <!-- Display Sort Key -->
                <p>
                  <strong>Sort Key:</strong>
                  {{
                    this.response.patient_profile.Items[0]?.sortKey || "None"
                  }}
                </p>

                <!-- Display Completed -->
                <p>
                  <strong>Completed:</strong>
                  {{
                    this.response.patient_profile.Items[0]?.completed
                      ? this.response.patient_profile.Items[0].completed.join(
                          ", "
                        )
                      : "None"
                  }}
                </p>
              </div>
            </ng-container>
          </div>
        </tr>
      </table>

      <ng-container
        *ngIf="
          isArray(response.schedules) && response?.schedules.length > 0;
          else noSchedules
        "
      >
        <div class="patient-schedule-header">
          <h1><strong id="patient-search-header">Schedules</strong></h1>

          <ng-container *ngIf="mquiDisplay">
            <button
              id="mqui-open"
              class="launch-mqui"
              #popover="ngbPopover"
              [ngbPopover]="inviteInfo"
              (click)="launchMqui()"
              (mouseenter)="popover.open()"
              (mouseleave)="popover.close()"
              placement="right"
              popoverTitle="MQUI Info"
            >
              Launch MQUI
            </button>

            <ng-template #inviteInfo>
              <p>
                <strong>Survey ID</strong>: {{ response.invite_data.surveyId }}
                <br />
                <strong>Day Offset</strong>:
                {{ response.invite_data.dayOffset }}
              </p>
            </ng-template>
          </ng-container>
        </div>
        <!-- Check if schedules is an array -->
        <ng-container *ngIf="isArray(response.schedules); else singleItem">
          <!-- Multiple schedules -->
          <div class="schedule-container">
            <ng-container *ngFor="let schedule of response.schedules">
              <div class="schedule-item">
                <!-- Parse the input JSON string -->
                <ng-container *ngIf="getParsedInput(schedule) as parsedInput">
                  <button
                    class="trigger-button"
                    (click)="
                      openFilledModal(
                        parsedInput.survey_id,
                        this.patientId,
                        parsedInput.day_offset,
                        parsedInput.device_serial
                      )
                    "
                  >
                    Trigger
                  </button>
                  <!-- Render schedule details here -->
                  <h3>
                    {{
                      regexExtract(
                        "(?:[^.]*\.){2}(.*)",
                        parsedInput.scheduler_name
                      )
                    }}
                  </h3>
                  <p>Scheduler Name: {{ parsedInput.scheduler_name }}</p>
                  <p>Survey ID: {{ parsedInput.survey_id }}</p>
                  <p>Source ID: {{ parsedInput.source_id }}</p>
                  <p>Day Offset: {{ parsedInput.day_offset }}</p>
                  <p>Device Serial: {{ parsedInput.device_serial }}</p>
                  <ng-container
                    *ngIf="
                      schedule.GroupName == 'survey_trigger_scheduler';
                      else push
                    "
                  >
                    <p>Type: App Pop-Up</p>
                  </ng-container>
                  <ng-template #push>
                    <p>Type: Push Notification</p>
                  </ng-template>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- Single schedule -->
        <ng-template #singleItem>
          <div class="schedule-container">
            <div class="schedule-item">
              <!-- Parse the input JSON string -->
              <ng-container
                *ngIf="getParsedInput(response.schedules) as parsedInput"
              >
                <!-- Render schedule details here -->
                <button
                  class="trigger-button"
                  (click)="
                    openFilledModal(
                      parsedInput.survey_id,
                      this.patientId,
                      parsedInput.day_offset,
                      parsedInput.device_serial
                    )
                  "
                >
                  Trigger
                </button>
                <h3>
                  {{
                    regexExtract(
                      "(?:[^.]*\.){2}(.*)",
                      parsedInput.scheduler_name
                    )
                  }}
                </h3>
                <p>Scheduler Name: {{ parsedInput.scheduler_name }}</p>
                <p>Survey ID: {{ parsedInput.survey_id }}</p>
                <p>Source ID: {{ parsedInput.source_id }}</p>
                <p>Day Offset: {{ parsedInput.day_offset }}</p>
                <p>Device Serial: {{ parsedInput.device_serial }}</p>
                <ng-container
                  *ngIf="
                    regexExtract('[^-]*-[^-]*-(.*)', response.schedules) ==
                      'survey_trigger_scheduler';
                    else push
                  "
                >
                  <p>Type: App Pop-Up</p>
                </ng-container>
                <ng-template #push>
                  <p>Type: Push Notification</p>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-template #noSchedules>
        <h1><strong id="patient-search-header">Schedules</strong></h1>
        <h2 id="patient-search-header">
          Patient does not have any active schedules
        </h2>
      </ng-template>
    </div>
  </main>
</div>
